(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["geo-article"] && !Shopify.designMode) return;
  try {
    
(function() {
  // FAQ accordion
  document.querySelectorAll('.geo-article__faq-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var dd = this.closest('.geo-article__faq-item').querySelector('.geo-article__faq-a');
      this.setAttribute('aria-expanded', String(!expanded));
      if (expanded) { dd.hidden = true; } else { dd.removeAttribute('hidden'); }
    });
  });

  // Smooth scroll for TOC links (both float and inline)
  // Fix v6: use scrollIntoView() instead of window.scrollTo() so the scroll
  // targets the element's nearest scrollable ancestor (container-agnostic).
  // On desktop the true scroll container is div.page-wrapper (overflow-y:auto);
  // window is nearly un-scrollable there, causing the old handler to clamp at ~32px.
  // scrollIntoView() resolves the correct container automatically on both desktop
  // and mobile. Offset is handled by scroll-margin-top:100px already on h2/h3.
  document.querySelectorAll('.geo-article__toc-link, .geo-article__toc-float .geo-article__toc-link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;
      var target = document.getElementById(href.slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // Scrollspy: highlight current section in floating TOC
  (function() {
    var floatList = document.getElementById('geo-toc-float-list');
    if (!floatList) return;
    var tocItems = floatList.querySelectorAll('[data-toc-id]');
    if (!tocItems.length) return;
    var headings = [];
    tocItems.forEach(function(item) {
      var id = item.getAttribute('data-toc-id');
      var el = document.getElementById(id);
      if (el) headings.push({ id: id, el: el, item: item });
    });
    if (!headings.length) return;
    var activeItem = null;
    function setActive(item) {
      if (activeItem === item) return;
      if (activeItem) activeItem.classList.remove('geo-toc-active');
      activeItem = item;
      if (activeItem) activeItem.classList.add('geo-toc-active');
    }
    function onScroll() {
      var scrollY = window.scrollY;
      var offset = 120;
      var current = null;
      for (var i = 0; i < headings.length; i++) {
        var top = headings[i].el.getBoundingClientRect().top + scrollY;
        if (scrollY + offset >= top) {
          current = headings[i].item;
        }
      }
      setActive(current || (headings.length ? headings[0].item : null));
    }
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function() { onScroll(); }, { rootMargin: '-100px 0px -60% 0px' });
      headings.forEach(function(h) { observer.observe(h.el); });
    } else {
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    onScroll();
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
